import PropTypes from 'prop-types'
import classNames from 'classnames'
import { get } from 'lodash'

import Icon from '../../icon'
import Typography from '../../typography'

import Check from '../../icon/check.svg'

const Requirements = ({ course, ...attrs }) => {
  const hasRequirements = get(course, 'requirementsList.length', 0) > 0

  return hasRequirements
    ? <div
      {...attrs}>
      <Typography
        size={'four'}
        weight={'black'}
        className={'mb-4'}>
        {course.requirementsTitle || 'Requisitos'}
      </Typography>
      {
        course.requirementsList.map(
          (item, index) => {
            const { text } = item.value
            const lastItem = (index === course.requirementsList.length - 1)
            return <div
              key={item.id}
              className={
                classNames([
                  'flex',
                  'flex-row',
                  'items-center',
                  !lastItem && 'mb-6'
                ])
              }>
              <Icon
                svg={Check}
                width={24}
                height={24}
                className={'mr-2 text-green-600'} />
              <Typography
                tag={'div'}
                size={'three'}
                weight={'regular'}>
                {text}
              </Typography>
            </div>
          }
        )
      }
    </div>
    : null
}

Requirements.propTypes = {
  course: PropTypes.object
}

export default Requirements
